<!-- <full-calendar [options]="calendarOptions"></full-calendar> -->
<mat-card class="links">
<div class="forweb">
    <button mat-stroked-button color="basic" [routerLink]="'/facility'" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" >Calendar</button>
    <button mat-stroked-button color="basic" [routerLink]="'/facility/cases'" routerLinkActive="active">Cases</button>
    <button mat-stroked-button color="basic" [routerLink]="'/facility/request'"  routerLinkActive="active" >Request</button>
    <button mat-stroked-button color="basic" [routerLink]="'/facility/scheduleList'"  routerLinkActive="active" >Scheduler List</button>
    <button mat-stroked-button color="basic" [routerLink]="'/facility/blockTime'"  routerLinkActive="active" >Block Time</button>
    <button mat-stroked-button color="basic" [routerLink]="'/facility/SchedulerCalendar'"  routerLinkActive="active" >Scheduler Calendar</button>
    <button mat-stroked-button color="basic" [routerLink]="'/facility/surgeryList'"  routerLinkActive="active">Surgery List</button>
    <button mat-stroked-button color="basic" [routerLink]="'/facility/waitingroom'"  routerLinkActive="active">Waiting Room</button>
</div>
<div class="forbelowipad">
    <mat-form-field >
        <mat-label>Select Module</mat-label>
        <mat-select>
          <mat-option value="one">Calendar</mat-option>
          <mat-option value="two">Cases</mat-option>
          <mat-option value="one">Request</mat-option>
          <mat-option value="two">Scheduler List</mat-option>
          <mat-option value="one">Block Time</mat-option>
          <mat-option value="two">Scheduler Calendar</mat-option>
          <mat-option value="two">Waiting Room</mat-option>
        </mat-select>
      </mat-form-field>
</div>
</mat-card>
  
<div class="faclityContainer" >
    <router-outlet></router-outlet>
</div>
